import { Grid, Tooltip, Chip, Card } from "@mui/material";
import styles from './Details.module.scss';
import chick from "../../../../assets/chick.jpeg"
import egg from "../../../../assets/egg.png"
import embryo from "../../../../assets/embriao.png";
import no_image from "../../../../assets/sem_imagem.png";

export const VehicleDetails = ({ vehicleDetails }) => {
    return (
        <Grid container className={styles.cardVehicle}>
            <Grid item xs={12} className={styles.plateAndChip}>
                <Tooltip title={vehicleDetails.typeOperation === "OVOS" ? "Ovos" : vehicleDetails.typeOperation === "PINTOS" ? "Pintinhos" : vehicleDetails.typeOperation === "EMBRIÕES" ? "Embriões" : ""} placement="top">
                    {(() => {
                        switch (vehicleDetails.typeOperation) {
                            case 'OVOS':
                                return <img src={egg} alt="Ícone" style={{ width: '25px', height: '25px', marginRight: '25px' }} />;
                            case 'PINTOS':
                                return <img src={chick} alt="Ícone" style={{ width: '35px', height: '35px', marginRight: '25px' }} />;
                            case "EMBRIÕES":
                                return <img src={embryo} alt="Ícone" style={{ width: '30px', height: '30px', marginRight: '25px' }} />;
                            default:
                                return <img src={no_image} alt="Ícone" style={{ width: '45px', height: '45px', marginRight: '25px' }} />;
                            // outros casos
                        }
                    })()}
                </Tooltip>
                <div className={styles.plateName}>
                    {vehicleDetails.vehiclePlate}

                </div>
                {
                    vehicleDetails.typeOperation === "OVOS" || vehicleDetails.typeOperation === "PINTOS" || vehicleDetails.typeOperation === "EMBRIÕES" ?
                        <Chip
                            className={` ${vehicleDetails.status === "START_ROUTE" ? styles.startRoute : vehicleDetails.status === "END_ROUTE" ? styles.endRoute : vehicleDetails.status === "IN_PATH" ? styles.inOrigin : vehicleDetails.status === "NOT_MONITORED" ? styles.notMonitored : styles.notMonitored}`}
                            label={vehicleDetails.status === "START_ROUTE" ? 'Na Origem' : vehicleDetails.status === "END_ROUTE" ? 'No Destino' : vehicleDetails.status === "IN_PATH" ? 'A Caminho' : vehicleDetails.status === 'NOT_MONITORED' ? 'Não Monitorado' : 'Desconhecido'}
                            size='small'
                            sx={{ marginLeft: "15px", marginTop: "8px" }}
                        />
                        :
                        <></>
                }

            </Grid>
            <Grid item xs={12}>
                <div className={styles.driverName}>
                    {vehicleDetails.driverName === "" ? vehicleDetails.name : ""}
                </div>
            </Grid>
        </Grid>
    );



}